import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'sg-pp-dialog',
  templateUrl: './pp-dialog.component.html',
  styleUrls: ['./pp-dialog.component.scss']
})
export class PpDialogComponent {

  @Output() PpDialogChange = new EventEmitter();

}
